import './combobox.less';

import '@reach/combobox/styles.css';

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import map from 'lodash/map';
import noop from 'lodash/noop';

import {
  Combobox,
  ComboboxInput,
  ComboboxPopover,
  ComboboxList,
  ComboboxOption
} from '@reach/combobox';

const ComboBox = ({
  label,
  className,
  openOnFocus,
  openDisplayInPortal,
  comboBoxIcon,
  inputProps,
  options,
  placeholder,
  persistSelection,
  onSelect,
  onInputChange
})=> (
  <Combobox
    aria-label={label}
    className={classNames('zf-combobox', className)}
    openOnFocus={openOnFocus}
    onSelect={onSelect}
    onBlur={noop} onKeyDown={noop}
  >

    <div className="zf-combobox-input-wrapper">
      {
        comboBoxIcon &&
          <span className="zf-combobox-icon">
            { comboBoxIcon }
          </span>
      }

      <ComboboxInput
        {...inputProps}
        placeholder={placeholder}
        onChange={onInputChange}
      />
    </div>

    <ComboboxPopover portal={openDisplayInPortal}>
      <ComboboxList persistSelection={persistSelection}>
        {
          map(options, ({ value, content })=> (
            <ComboboxOption key={value} value={value}>
              { content }
            </ComboboxOption>
          ))
        }
      </ComboboxList>
    </ComboboxPopover>

  </Combobox>
);

ComboBox.propTypes = {
  className: PropTypes.string,
  placeholder: PropTypes.string,
  inputProps: PropTypes.object,
  label: PropTypes.string.isRequired,
  comboBoxIcon: PropTypes.node,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    content: PropTypes.node
  })).isRequired,
  persistSelection: PropTypes.bool,
  onSelect: PropTypes.func,
  onInputChange: PropTypes.func
};

ComboBox.defaultProps = {
  openOnFocus: false,
  openDisplayInPortal: true,
  persistSelection: true
};

export default ComboBox;
